/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    first_name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        64,
        i18n.t('MAX_LENGTH_KEY', {
          value: 64,
        })
      ),
    last_name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        64,
        i18n.t('MAX_LENGTH_KEY', {
          value: 64,
        })
      ),
    email: Yup.string()
      .email(i18n.t('EMAIL_INVALID_KEY'))
      .required(i18n.t('REQUIRED_FIELD_KEY')),
  });
};
